import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "filter-container mt-6" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_4 = { class: "col-span-4" }
const _hoisted_5 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_6 = { value: null }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-span-4" }
const _hoisted_9 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_10 = { value: null }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-span-4" }
const _hoisted_13 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_14 = { class: "col-span-4" }
const _hoisted_15 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_16 = { class: "col-span-4" }
const _hoisted_17 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_18 = { class: "col-span-4" }
const _hoisted_19 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_20 = { class: "col-span-4" }
const _hoisted_21 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_22 = { class: "mt-10" }
const _hoisted_23 = { class: "filter-container mt-10" }
const _hoisted_24 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_25 = ["id", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "mt-10 flex justify-between" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "flex flex-row-reverse" }
const _hoisted_31 = ["onSubmit"]
const _hoisted_32 = { class: "block text-sm font-medium text-gray-700" }

import { computed, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import {
  DocumentDownloadIcon,
  DownloadIcon,
  SaveIcon,
  SearchIcon,
} from "@heroicons/vue/outline";
import VueTableLite from "vue3-table-lite/ts";
import PublicId from "@/components/common/PublicId.vue";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { Button } from "@/components/common";
import Modal from "@/components/common/Modal.vue";
import ReportTemplateModal from "@/components/report/ReportTemplateModal.vue";
import ReportFileModal from "@/components/report/ReportFileModal.vue";
import { ReportActions } from "@/store/modules/report/actions";
import { ReportGetters } from "@/store/modules/report/getters";
import { ReportTemplateActions } from "@/store/modules/reportTemplate/actions";
import ReportDataService from "@/services/report/ReportDataService";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import {
  DocumentReportFieldConfig,
  DocumentReportFieldKey,
  DocumentReportFilterType,
  ReportTemplate,
  ReportTemplateType,
} from "@/types/report/ReportTypes";
import { downloadBlob, XLSX_MIME } from "@/utils/downloadBlob";
import { formatReportParamDate, omitEmptyParams } from "@/utils/reportParams";
import { t } from "@/i18n";
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const toast = useToast();

const categories = ref<Array<{ id: string; name: string }>>([]);
const exportLoading = ref(false);
const saveModalIsShow = ref(false);
const templateModalIsShow = ref(false);
const reportFileModalIsShow = ref(false);
const templateName = ref("");

const reportTypeOptions = [
  {
    value: DocumentReportFilterType.COMPLETED_ON_TIME,
    label: t("reports.typeCompletedOnTime"),
  },
  {
    value: DocumentReportFilterType.OVERDUE,
    label: t("reports.typeOverdue"),
  },
  {
    value: DocumentReportFilterType.IN_PROGRESS,
    label: t("reports.typeInProgress"),
  },
  {
    value: DocumentReportFilterType.REJECTED,
    label: t("reports.typeRejected"),
  },
];

const columnOptions = [
  { field: "id", label: t("reports.columnId"), width: "160px" },
  { field: "documentNumber", label: t("reports.columnDocumentNumber") },
  { field: "creatorFullName", label: t("reports.columnCreatorFullName") },
  { field: "title", label: t("reports.theme") },
  { field: "subCategoryName", label: t("reports.columnSubCategoryName") },
  { field: "receiversNames", label: t("reports.columnReceiversNames") },
  { field: "subdivisionName", label: t("reports.columnSubdivisionName") },
  { field: "esedoSenderName", label: t("reports.columnEsedoSenderName") },
  { field: "status", label: t("reports.status") },
  { field: "incomingNumber", label: t("reports.columnIncomingNumber") },
  { field: "outgoingNumber", label: t("reports.columnOutgoingNumber") },
  { field: "executors", label: t("reports.columnExecutors") },
  { field: "deadline", label: t("reports.columnDeadline") },
  { field: "finishedAt", label: t("reports.columnFinishedAt") },
];

const defaultColumns = [
  "documentNumber",
  "creatorFullName",
  "subCategoryName",
  "receiversNames",
  "subdivisionName",
  "executors",
  "deadline",
  "finishedAt",
];

const selectedColumns = ref([...defaultColumns]);

const filter = ref({
  type: null as number | null,
  documentCategoryId: null as string | null,
  subCategory: "",
  createdAtStart: null as Date | null,
  createdAtEnd: null as Date | null,
  finishedAtStart: null as Date | null,
  finishedAtEnd: null as Date | null,
});

const dataProvider = computed(
  () => store.getters[ReportGetters.GET_DATA_PROVIDER]
);
const items = computed(() => dataProvider.value.items);
const pager = computed(() => dataProvider.value.pager);

const visibleColumns = computed(() =>
  columnOptions.filter((column) => selectedColumns.value.includes(column.field))
);

const table = reactive({
  isLoading: false,
  columns: visibleColumns,
  rows: items,
  totalRecordCount: 0,
});

const buildFieldConfig = (): DocumentReportFieldConfig => {
  const keys: DocumentReportFieldKey[] = [
    "id",
    "documentNumber",
    "creatorFullName",
    "title",
    "subCategoryName",
    "receiversNames",
    "subdivisionName",
    "esedoSenderName",
    "status",
    "incomingNumber",
    "outgoingNumber",
    "executors",
    "deadline",
    "finishedAt",
  ];

  return keys.reduce((acc, key) => {
    acc[key] = selectedColumns.value.includes(key);
    return acc;
  }, {} as DocumentReportFieldConfig);
};

const buildParamConfig = () =>
  omitEmptyParams({
    type: filter.value.type != null ? String(filter.value.type) : null,
    documentCategoryId:
      filter.value.documentCategoryId != null
        ? String(filter.value.documentCategoryId)
        : null,
    subCategory: filter.value.subCategory,
    createdAtStart: formatReportParamDate(filter.value.createdAtStart),
    createdAtEnd: formatReportParamDate(filter.value.createdAtEnd),
    finishedAtStart: formatReportParamDate(filter.value.finishedAtStart),
    finishedAtEnd: formatReportParamDate(filter.value.finishedAtEnd),
  });

const buildListParams = (page = 1) => ({
  page,
  ...buildParamConfig(),
});

const getPage = async (page: number) => {
  await store.dispatch(ReportActions.FETCH_DATA_PROVIDER, buildListParams(page));
};

const updateFilter = async () => {
  await getPage(1);
};

const exportReport = async () => {
  exportLoading.value = true;
  try {
    const response = await ReportDataService.exportDocumentReport({
      filename: "documents-report.xlsx",
      fieldConfig: buildFieldConfig(),
      paramConfig: buildParamConfig(),
    });
    downloadBlob(new Blob([response.data], { type: XLSX_MIME }), "documents-report.xlsx");
    toast.success(t("reports.exportSuccess"));
  } catch (error) {
    console.error(error);
    toast.error(t("reports.exportError"));
  } finally {
    exportLoading.value = false;
  }
};

const saveTemplate = async () => {
  await store.dispatch(ReportTemplateActions.CREATE, {
    name: templateName.value,
    reportType: ReportTemplateType.DOCUMENT_EXPORT,
    fieldConfig: buildFieldConfig(),
    paramConfig: buildParamConfig(),
  });

  templateName.value = "";
  saveModalIsShow.value = false;
  toast.success(t("reports.templateSaved"));
};

const applyTemplate = (data: { value: ReportTemplate }) => {
  const template = data.value;
  const params = template.paramConfig;

  filter.value.type = params.type ? Number(params.type) : null;
  filter.value.documentCategoryId = params.documentCategoryId
    ? String(params.documentCategoryId)
    : null;
  filter.value.subCategory = params.subCategory ?? "";
  filter.value.createdAtStart = params.createdAtStart
    ? new Date(params.createdAtStart)
    : null;
  filter.value.createdAtEnd = params.createdAtEnd
    ? new Date(params.createdAtEnd)
    : null;
  filter.value.finishedAtStart = params.finishedAtStart
    ? new Date(params.finishedAtStart)
    : null;
  filter.value.finishedAtEnd = params.finishedAtEnd
    ? new Date(params.finishedAtEnd)
    : null;

  selectedColumns.value = Object.entries(template.fieldConfig)
    .filter(([, enabled]) => enabled)
    .map(([field]) => field);

  templateModalIsShow.value = false;
  updateFilter();
};

onMounted(async () => {
  await getPage(1);
  categories.value = (
    await DocumentDataService.getConstructorFilter()
  ).data.data.items;
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(updateFilter, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)("reports.reportTypeFilter")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.type) = $event)),
              class: "block w-full rounded-lg border-gray-300"
            }, [
              _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(t)("common.allReportTypes")), 1),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reportTypeOptions, (option) => {
                return _createElementVNode("option", {
                  key: option.value,
                  value: option.value
                }, _toDisplayString(option.label), 9, _hoisted_7)
              }), 64))
            ], 512), [
              [_vModelSelect, filter.value.type]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("reports.documentCategory")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.documentCategoryId) = $event)),
              class: "block w-full rounded-lg border-gray-300"
            }, [
              _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("common.allCategories")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: category.id,
                  value: category.id
                }, _toDisplayString(category.name), 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, filter.value.documentCategoryId]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("reports.subCategory")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.subCategory) = $event)),
              type: "text",
              class: "block w-full rounded-lg border-gray-300"
            }, null, 512), [
              [_vModelText, filter.value.subCategory]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)("reports.createdAtStart")), 1),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: filter.value.createdAtStart,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.createdAtStart) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              autoApply: true
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)("reports.createdAtEnd")), 1),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: filter.value.createdAtEnd,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.createdAtEnd) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              autoApply: true
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)("reports.finishedAtStart")), 1),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: filter.value.finishedAtStart,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.finishedAtStart) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              autoApply: true
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)("reports.finishedAtEnd")), 1),
            _createVNode(_component_Datepicker, {
              locale: "ru",
              selectText: _unref(t)('logs.apply'),
              cancelText: _unref(t)('logs.cancel'),
              placeholder: _unref(t)('logs.datePlaceholder'),
              enableTimePicker: false,
              modelValue: filter.value.finishedAtEnd,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filter.value.finishedAtEnd) = $event)),
              format: "dd/MM/yyyy",
              previewFormat: "dd/MM/yyyy",
              autoApply: true
            }, null, 8, ["selectText", "cancelText", "placeholder", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(Button), {
            type: "submit",
            class: "btn-search"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
            ]),
            _: 1
          })
        ])
      ], 40, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnOptions, (column) => {
          return _createElementVNode("div", {
            key: column.field,
            class: "col-span-4"
          }, [
            _withDirectives(_createElementVNode("input", {
              id: `column-${column.field}`,
              type: "checkbox",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedColumns).value = $event)),
              value: column.field
            }, null, 8, _hoisted_25), [
              [_vModelCheckbox, selectedColumns.value]
            ]),
            _createElementVNode("label", {
              class: "pl-2",
              for: `column-${column.field}`
            }, _toDisplayString(column.label), 9, _hoisted_26)
          ])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_unref(Button), {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (saveModalIsShow.value = true)),
            class: "flex px-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SaveIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("reports.saveReport")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (templateModalIsShow.value = true)),
            class: "flex px-10 ml-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SaveIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("reports.savedReports")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_unref(Button), {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (reportFileModalIsShow.value = true)),
            class: "flex px-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DocumentDownloadIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("reports.reportFiles")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            onClick: exportReport,
            class: "flex px-10 ml-2",
            disabled: exportLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DownloadIcon), { class: "button-icon mr-2" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("reports.excelExport")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      class: "mt-6 report-table",
      style: _normalizeStyle({ '--report-columns': _unref(visibleColumns).length }),
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      id: _withCtx((data) => [
        _createVNode(PublicId, {
          value: data.value.id,
          compact: ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "style", "messages"]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[12] || (_cache[12] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ]),
    _createVNode(Modal, {
      title: _unref(t)('reports.saveTemplateTitle'),
      show: saveModalIsShow.value,
      onClose: _cache[14] || (_cache[14] = ($event: any) => (saveModalIsShow.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(saveTemplate, ["prevent"])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(t)("reports.name")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((templateName).value = $event)),
              type: "text",
              class: "w-full rounded-lg border-gray-300"
            }, null, 512), [
              [_vModelText, templateName.value]
            ])
          ]),
          _createVNode(_unref(Button), {
            class: "flex px-10 mt-4",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("reports.save")), 1)
            ]),
            _: 1
          })
        ], 40, _hoisted_31)
      ]),
      _: 1
    }, 8, ["title", "show"]),
    _createVNode(ReportTemplateModal, {
      show: templateModalIsShow.value,
      "report-type": _unref(ReportTemplateType).DOCUMENT_EXPORT,
      onSelect: applyTemplate,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (templateModalIsShow.value = false))
    }, null, 8, ["show", "report-type"]),
    _createVNode(ReportFileModal, {
      show: reportFileModalIsShow.value,
      onClose: _cache[16] || (_cache[16] = ($event: any) => (reportFileModalIsShow.value = false))
    }, null, 8, ["show"])
  ]))
}
}

})